import { HOST_URL } from '.'

export const TAGS_API = (jobNumber: number | undefined): string => {
    return `${HOST_URL}/ops/jobs/${jobNumber}/tags`
}

export default TAGS_API
